export const LOCALSTORAGE_KEYS = {
  PARKED_CUSTOMER_CART: 'parked_customer_cart',
  SOFT_LOGOUT_ACCOUNT_DETAILS: 'rc_details',
  CUSTOMER_POSTALCODE: 'rc_postCode',
  REGIONAL_INDEXES_CONFIG: 'regionalIndexesConfig',
} as const

export const COOKIES_KEYS = {
  SHIPPING_POSTALCODE: 'dw_shippostalcode',
} as const
